import { useEffect } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import moengage from "@moengage/web-sdk";

import LoaderContainer from "app/components/ui/LoaderContainer";
import {
  ACTIVE_CUSTOMER_KEY,
  ACTIVE_PROFILE_ID_QUERY_PARAM,
  ACTIVE_PROFILE_STORAGE_KEY,
} from "app/constants/variables";
import { useSetToken, useToken } from "app/providers/TokenProvider";
import { getUserDetailsFromToken } from "app/lib/encryption";
import storage from "app/lib/storage";
import { useSetActiveProfile } from "app/providers/ActiveProfileProvider";
import useGetProfiles from "app/hooks/useGetProfiles";
import ProfileSelector from "./components/ProfileSelector";
import { ActiveProfile } from "app/models/profile";

export default function Auth() {
  const params = useParams();
  const accessToken = params.token;
  const [searchParams] = useSearchParams();
  const refresh_token = searchParams.get("refresh_token") ?? undefined;
  const activeProfileId = searchParams.get(ACTIVE_PROFILE_ID_QUERY_PARAM);
  const setActiveProfile = useSetActiveProfile();
  const { profiles, getProfiles } = useGetProfiles(true, accessToken);

  const setAppTokens = useSetToken();
  const token = useToken();

  useEffect(() => {
    let tokens = {
      access_token: accessToken,
      refresh_token,
    };

    setAppTokens(tokens);

    async function initializeUser() {
      const data = await getUserDetailsFromToken(accessToken!);
      // REFRESH ACTIVE_PROFILE_ID (IF ANY) TO AVOID PROFILE CONFLICT
      storage.remove(ACTIVE_PROFILE_STORAGE_KEY);
      storage.remove(ACTIVE_CUSTOMER_KEY);
      await moengage.add_unique_user_id(data?.userId);
      await moengage.track_event("login", {
        user_id: data?.userId,
        login_method: data?.userEmail,
        platform: "web",
      });
    }

    initializeUser();
  }, [
    params.token,
    refresh_token,
    setAppTokens,
    setActiveProfile,
    activeProfileId,
  ]);

  useEffect(() => {
    if (token) {
      const fetchProfiles = async () => {
        await getProfiles();
      };
      fetchProfiles();
    }
  }, [token, profiles]);

  return profiles && profiles?.length > 0 ? (
    <ProfileSelector profiles={profiles as ActiveProfile[]} />
  ) : (
    <LoaderContainer loading screen />
  );
}
